import React from 'react';
import { useModal } from '../../../../components/Modal/PresentedModal';
import { t } from '../../../../locales/translate';
import { FormForm } from '../../../../components/Form/FormForm';
import { handleError } from '../../../../model/notification';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { FormSearch } from '../../../../components/Form/AsyncSearch/FormSearch';
import { useMutation } from '@apollo/client';
import { graphql } from '../../../../generated';

type Props = { orderId: string; shopId: string | null | undefined };

const UPDATE_ORDER = graphql(`
  mutation UpdateOrder($id: ID!, $shopId: ID) {
    updateOrder(input: { id: $id, shopId: $shopId }) {
      order {
        id
        shop {
          id
        }
      }
    }
  }
`);

export function UpdateShopModal({ orderId, shopId }: Props): JSX.Element {
  const { open, Modal, close } = useModal();

  const [updateOrder] = useMutation(UPDATE_ORDER);

  const { model, fields, onSubmit, dirty, valid, submissionStatus } = useForm<{
    shopId: string | null | undefined;
  }>({
    model: {
      shopId,
    },
    onSubmit: async () => {
      await updateOrder({
        variables: {
          id: orderId,
          shopId: model.shopId || null,
        },
      });
      close();
    },
    onSubmitError: handleError,
  });

  return (
    <Modal open={open} title={t.model.order.shopDetails.update}>
      <FormForm
        onSubmit={onSubmit}
        onClose={close}
        canSubmit={dirty && valid}
        loading={submissionStatus === 'submitting'}
      >
        <FormSearch {...fields.shopId} name="shopName" searchIn={['shop']} label={t.model.order.shopDetails.shop} />
      </FormForm>
    </Modal>
  );
}
